// extracted by mini-css-extract-plugin
export var chevron = "_1w-d";
export var disabled = "_1w-b";
export var error = "_1w-c";
export var hideBorder = "_1w-1";
export var icon = "_1w-e";
export var input = "_1w-0";
export var large = "_1w-f";
export var open = "_1w-9";
export var placeholder = "_1w-a";
export var regular = "_1w-5";
export var singleRowInput = "_1w-2";
export var singleSelectInput = "_1w-3 _1w-0";
export var small = "_1w-4";
export var spinnerContainer = "_1w-i";
export var tag = "_1w-7";
export var tagsContainer = "_1w-8";
export var tagsInput = "_1w-6 _1w-0";
export var xSmall = "_1w-g";
export var xxSmall = "_1w-h";